import { toast } from 'react-toastify';
import { waitDialog } from 'dialogs';
import type { CreateTarget } from 'actions';
import { getLock, type FetchedLock } from 'api/locks/endpoints/getLock';
import EditLockModal from '../EditLockModal';

export type ShowEditLockArgs = { readonly mode: 'create'; readonly createIn?: CreateTarget } | { readonly mode: 'edit'; readonly id: number };

/**
 * Open the lock create / edit modal and resolve when it closes (so the caller
 * can refresh). Standalone async: for edit it always fetches the record by id
 * (boundary-validated), so it works from the Workspace — which never populates
 * the list slice — and never opens the modal on a loosely-cast store row.
 */
export const showEditLock = async (args: ShowEditLockArgs): Promise<void> => {
  const createIn = args.mode === 'create' ? args.createIn : undefined;
  let data: FetchedLock | null = null;
  if (args.mode === 'edit') {
    data = await getLock(args.id);
    if (!data) {
      toast.error('Lock not found; the list may be out of date. Please refresh.');
      return;
    }
  }
  await waitDialog<void>((ok) => <EditLockModal show handleClose={ok} mode={args.mode} data={data} createIn={createIn} />);
};
